<template>
  <div style="font-size: 13px">
    <template v-if="!loading">
      <!-- <b style="color:red">{{informText}}</b> -->
      <v-alert type="error" v-if="informText != ''">
        {{ informText }}
      </v-alert>
      <v-col cols="12">
        <v-row>
          <v-col cols="3">Export</v-col>
          <v-col cols="9" style="text-align: left">
            <v-col cols="12">
              <!-- <input class="form-check-input" type="radio" name="radio" id="all" value="All" v-model="selected">
                            <label class="form-check-label" for="all">
                                All Items
                            </label>
                            <br>
                                <template v-if="selectedItem.length > 0">
                                    <input class="form-check-input" type="radio" name="radio" id="selected" :value="selectedItem.length" v-model="selected">
                                    <label class="form-check-label" for="selected">
                                        Selected Item(s) ({{selectedItem.length}})
                                    </label>
                                </template>
                                <template v-else>
                                    <input class="form-check-input" type="radio" name="radio" id="selected" :value="selectedItem.length" v-model="selected" disabled>
                                    <label class="form-check-label" for="selected">
                                        Selected Item(s)
                                    </label>
                                </template>
                            <br>
                            <input class="form-check-input" type="radio" name="radio" id="missing" value="MissingOnes" v-model="selected">
                            <label class="form-check-label" for="missing">
                                Only the missing ones
                            </label>
                            <br>
                            <input class="form-check-input" type="radio" name="radio" id="matching" value="MatchingFilters" v-model="selected">
                            <label class="form-check-label" for="matching">
                                Products matching your search
                            </label>   -->
              <v-radio-group
                v-model="selected"
                :mandatory="false"
                class="small"
              >
                <v-radio
                  :label="selectedItemText"
                  :value="selectedItem.length"
                  v-if="selectedItem.length > 0"
                ></v-radio>
                <v-radio
                  :label="selectedItemText"
                  :value="selectedItem.length"
                  v-else
                  disabled=""
                ></v-radio>
                <v-radio
                  label="Products matching your search"
                  value="MatchingFilters"
                  v-if="filterData.dates.length > 0 || filterData.status != ''"
                ></v-radio>
                <v-radio
                  label="Products matching your search"
                  value="MatchingFilters"
                  v-else
                  disabled
                ></v-radio>
              </v-radio-group>
            </v-col>

            <!-- <v-col cols="12" v-if="selectedItem.length > 0">
                            <input class="form-check-input" type="radio" name="radio" id="selected" :value="selectedItem.length" v-model="selected">
                            <label class="form-check-label" for="selected">
                                Selected Item(s) ({{selectedItem.length}})
                            </label>
                        </v-col>

                        <v-col cols="12" v-else>
                            <input class="form-check-input" type="radio" name="radio" id="selected" :value="selectedItem.length" v-model="selected" disabled>
                            <label class="form-check-label" for="selected">
                                Selected Item(s)
                            </label>
                        </v-col>

                        <v-col cols="12">
                            <input class="form-check-input" type="radio" name="radio" id="missing" value="MissingOnes" v-model="selected">
                            <label class="form-check-label" for="missing">
                                Only the missing ones
                            </label>
                        </v-col>

                        <v-col cols="12">
                            <input class="form-check-input" type="radio" name="radio" id="missing" value="MissingOnes" v-model="selected">
                            <label class="form-check-label" for="missing">
                                Products matching your search
                            </label>
                        </v-col>                -->
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="3">#Order</v-col>
          <v-col cols="9">
            <template v-if="selected == selectedItem.length">
              <!-- {{listOrderID.join(", ")}} -->
              {{ listOrderNum.join(", ") }}
            </template>
            <template v-else-if="selected == 'MatchingFilters'">
              Products matching your search
            </template>
            <template v-else></template>
            <!-- {{listOrderID}} -->
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="3">Current Filter</v-col>
          <v-col cols="9">
            |
            <template v-if="filterData.searchBy != ''"
              ><b>Search By: </b>{{ filterData.searchBy }} |
            </template>
            <template v-if="filterData.searchWord != ''"
              ><b>Search Word: </b>{{ filterData.searchWord }} |
            </template>
            <template v-if="filterData.dates.length > 0"
              ><b>Created Date: </b>{{ filterData.dates.join(" ~ ") }} |
            </template>
            <template v-if="filterData.status != ''"
              ><b>Status: </b>{{ filterData.status }} |
            </template>
            <template v-if="filterData.siteCodes.length > 0 != ''"
              ><b>Site(s): </b>{{ filterData.siteCodes }} |
            </template>
            <template v-if="filterData.vendorId != ''"
              ><b>Vendor: </b>{{ vendor_name }} |
            </template>
            <template v-if="filterData.productTypeId != ''"
              ><b>Product Type: </b>{{ productTypeName }} |
            </template>
            <template v-if="filterData.platform != ''"
              ><b>Platform: </b>{{ filterData.platform }} |
            </template>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-btn color="success" @click="exportData" v-if="selected != ''">
              Export Data
            </v-btn>
            <v-btn color="success" @click="exportData" v-else disabled>
              Export Data
            </v-btn>
            &nbsp;

            <v-btn class="white--text" color="warning" @click="cancelData">
              Cancel <v-icon right dark>mdi-window-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </template>
    <template v-else>
      <img v-bind:src="require('../../assets/loading/loading.gif')" />
    </template>
  </div>
</template>

<script>
//import axios from "axios"
//import Vue from "vue";
//import HTTP from "../http-common"
import Amplify, { Auth } from "aws-amplify";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "ExportProduct",
  props: {
    selectedItem: Array,
    username: String,
    filterData: Object,
    listProductType: Array,
    listVendors: Array,
  },
  data: () => ({
    loading: false,
    AuthStr: "",
    listOrderID: [],
    listOrderNum: [],
    selected: "",
    informText: "",
    radios: "radio-1",
    selectedItemText: "",
    itemSelected: [],
    productTypeName: "",
    vendor_name: "",
  }),
  methods: {
    async exportData() {
      this.loading = true;
      var create_from = "";
      var create_to = "";

      if (this.filterData.dates.length > 0) {
        console.log(this.filterData.dates);
        if (this.filterData.dates[0] > this.filterData.dates[1]) {
          create_from = this.filterData.dates[1];
          create_to = this.filterData.dates[0];
        } else {
          create_from = this.filterData.dates[0];
          create_to = this.filterData.dates[1];
        }
      }

      var filter = {
        searchBy: this.filterData.searchBy,
        searchWord: this.filterData.searchWord,
        status: "",
        created_from: "",
        created_to: "",
        siteCodes: this.filterData.siteCodes,
        platform: this.filterData.platform,
      };

      if (this.filterData.status != "") {
        filter.status = this.filterData.status;
      }

      if (this.filterData.dates.length > 0) {
        filter.created_from = create_from;
        filter.created_to = create_to;
      }

      var item = {
        export: this.selected,
        order_ids: this.listOrderID,
        filters: filter,
      };

      console.log(JSON.stringify(item));
      var currentSession = await this.$root.$refs.App.currentSession(
        "order-export-exportData"
      );
      //console.log('currentSession: ',currentSession.accessToken)
      if (currentSession.accessToken) {
        await fetch(window.domain + "orders/fulfill-orders", {
          method: "POST",
          headers: { Authorization: currentSession.accessToken },
          body: JSON.stringify(item),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("exportData: ", data);
            console.log("data.message: ", data.message);
            //var error = data.error_message.toString()
            if (data.error_message == "") {
              this.$root.$refs.order.showAlert("export", null);
            } else if (data.message == "Service Unavailable") {
              this.$root.$refs.order.showAlert("export", null);
            } else {
              this.loading = false;
              this.informText = data.error_message;
              return;
            }
          })
          .catch((error) => {
            console.log("Error:", error);
          });
      } else {
        console.log(
          "currentSession order-export-exportData-undefined: ",
          currentSession
        );
      }
    },

    cancelData() {
      this.$root.$refs.order.turnOffDialog();
    },
  },
  async mounted() {
    console.log("filterData: ", this.filterData);
    //console.log(this.listVendors)

    if (this.filterData.vendorId != "") {
      for (const i of this.listVendors) {
        if (i._id == this.filterData.vendorId) {
          this.vendor_name = i.vendor_code;
        }
      }
    }

    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
      //let username = currentUser.username;
      //userLoggedIn = true;
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }

    for (const i of this.selectedItem) {
      this.listOrderID.push(i.order_id);
      this.listOrderNum.push(i.order_number);
    }

    if (this.filterData.productTypeId != "") {
      for (const i of this.listProductType) {
        if (this.filterData.productTypeId == i._id) {
          this.productTypeName = i.product_type;
        }
      }
    }

    this.selectedItemText = "Selected " + this.selectedItem.length + " Item(s)";
  },
};
</script>

<style scoped>
.v-label {
  font-size: 13px;
}

.v-input--selection-controls__input {
  font-size: 13px;
}
</style>